module.exports = __webpack_public_path__ + "static/media/gestoria_verde.80cafd9f.svg";